export default "__VITE_ASSET__CJFBWW$c__"